import { useEffect, useState } from 'react'
import SelectBox from 'devextreme-react/select-box';
import { RxCross2 } from "react-icons/rx";
import { useCart } from '../../Providers/CartProvider';
import { toast } from 'react-toastify';
import TextBox from 'devextreme-react/text-box';
import { BsCartPlus } from "react-icons/bs";
import Product from '../../Pages/Shop/Components/ProductComponents/Product';
import useChangeIsProductSelected from './Hooks/useChangeIsProductSelected';
import YesNoCancelMessageModal from '../Components/Modals/YesNoCancelMessageModal';
import YesNoMessageModal from '../Components/Modals/YesNoMessageModal';
import LoadingSpinner from '../Components/LoadingSpinner';
import { useSavedBaskets } from '../../Providers/SavedBasketsProvider';
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { useParams } from '../../Providers/ParamsProvider';

import './Styles/CartProductsStyles.css'
import { useOffers } from '../../Providers/OffersProvider';

const CartProducts = ({ setLockProceed }) => {
  const navigate = useNavigate()
  const { handleSaveBasket, savedBaskets, handleGetSavedBasket } = useSavedBaskets()
  const { cartItems, deleteAllItems, loadBasket, deleteInCart, getBasket } = useCart()
  const [selectedBasket, setSelectedBasket] = useState(null)
  const [showSaveBasketForm, setShowSaveBasketForm] = useState(false)
  const [basketName, setBasketName] = useState('')
  const [showQuestionAboutReplaceBasket, setShowQuestionAboutReplaceBasket] = useState(false)
  const { handleChangeIsProductSelected } = useChangeIsProductSelected()
  const [showClearBasketModal, setShowClearBasketModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { isMobile } = useParams()
  const [isLoadingClearBasket, setIsLoadingClearBasket] = useState(false)
  const { orderItemsFromOffer } = useOffers()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleBasketChange = async (e) => {
    if (e.value) {
      setSelectedBasket(e.value)
      if (cartItems.basketItems && cartItems.basketItems.length > 0) {
        setShowQuestionAboutReplaceBasket(true)
      }
      else {
        setIsLoading(true)
        await loadBasket(e.value.basketId, false)
        setIsLoading(false)
      }
    }
  }
  const handleShowHideNameForm = () => {
    setShowSaveBasketForm(prev => !prev)
  }
  const handleSaveBasketFunc = async () => {
    if (validData()) {
      setShowSaveBasketForm(false)
      setBasketName('')
      if (await handleSaveBasket(cartItems.basketItems, basketName)) {
        toast.success('Zapisano koszyk')
        handleGetSavedBasket()
      }
    }
  }
  const handleDeleteAllItems = async () => {
    setSelectedBasket(null)
    setShowSaveBasketForm(false)
    await deleteAllItems()
  }
  const handleChangeBasketName = (e) => {
    setBasketName(e.value)
  }
  const validData = () => {
    let result = true
    if (cartItems.basketItems.length === 0) {
      toast.warning('Brak pozycji w koszyku!')
      result = false
    }
    if (basketName === null || basketName === undefined || basketName === '' || basketName.trim() === '') {
      toast.warning('Prosze wpisać nazwę koszyka')
      result = false
    }
    return result
  }

  const handleRemoveClick = (product) => {
    deleteInCart(product)
  }
  const handleMessageModalResult = async (answer) => {
    if (answer !== 'Cancel') {
      const replaceBasket = answer === 'Yes' ? true : false
      setIsLoading(true)
      await loadBasket(selectedBasket.basketId, replaceBasket)
      setIsLoading(false)
    }
    setShowQuestionAboutReplaceBasket(false)
  }
  const handleSelectProduct = async (index) => {
    await handleChangeIsProductSelected(index, true)
  }
  const handleUnselectProduct = async (index) => {
    await handleChangeIsProductSelected(index, false)
  }
  const handleClearBasket = async (answer) => {
    if (answer) {
      setIsLoadingClearBasket(true)
      await handleDeleteAllItems()
      setIsLoadingClearBasket(false)
    }
    setShowClearBasketModal(false)
  }

  let clearBasketButtonStyle = cartItems.basketItems && cartItems.basketItems.length > 0 ? '' : 'collapse'
  let realizeOfferStyle = orderItemsFromOffer && orderItemsFromOffer.length > 0 ? 'd-none' : ''

  const generateProducts = () => {
    let products = orderItemsFromOffer && orderItemsFromOffer.length > 0 ? orderItemsFromOffer : cartItems.basketItems
    if (products && products.length > 0) {
      return products.map((item, key) => {
        return <Product
          key={item.artNo}
          product={item.product}
          isBasketSummary={true}
          additionalOptions={{ handleSelectProduct, handleUnselectProduct, handleRemoveClick, isCheckboxSelected: item.isSelected }}
          setLockProceed={setLockProceed}
          blockSetPriceFromBasket={true}
        />
      })
    }
    return null
  }

  if (isLoadingClearBasket) {
    return <LoadingSpinner loadingText='Czyszczenie koszyka...' />
  }
  if (isLoading) {
    return <LoadingSpinner />
  }
  return (
    <>
      <YesNoCancelMessageModal
        show={showQuestionAboutReplaceBasket}
        onHide={handleMessageModalResult}
        title={'Pytanie'}
        message={'Co chcesz zrobić z pozycjami w koszyku?'}
        yesText='Nadpisz koszyk'
        noText='Dopisz do koszyka'
        cancelText='Anuluj'
      />
      <YesNoMessageModal
        show={showClearBasketModal}
        onHide={handleClearBasket}
        title={'Pytanie'}
        message={'Czy na pewno chcesz usunąć wszystkie pozycję z koszyka?'}
      />

      <div className={`${realizeOfferStyle} row mb-3 d-flex align-items-center`}>
        <div className="col-auto mb-3 mb-xxl-0">
          <SelectBox
            dataSource={savedBaskets}
            placeholder="Lista zapisanych koszyków"
            displayExpr={'name'}
            showClearButton={false}
            className="cart-page-select-box"
            onValueChanged={(e) => handleBasketChange(e)}
            noDataText='Brak koszyków'
            value={selectedBasket}
          />
        </div>
        <div className={`col-auto`}>
          <div className='ms-3 d-flex align-items-center' style={{ cursor: 'pointer' }} onClick={handleShowHideNameForm}>
            <BsCartPlus size={20} />
            <b className='user-select-none'>Utwórz szybkokoszyk</b>
          </div>
        </div>
        <div className={`col-auto ms-auto`}>
          <div className={`d-flex align-items-center text-secondary ${clearBasketButtonStyle}`} style={{ marginLeft: "auto", cursor: 'pointer' }} onClick={() => setShowClearBasketModal(true)}>
            <RxCross2 size={25} />
            <span className={`ms-2 user-select-none`}>Wyczyść koszyk</span>
          </div>
        </div>
      </div>

      <div>
        {showSaveBasketForm && (
          <div className='d-flex mb-4'>
            <TextBox
              placeholder={'Nazwa koszyka'}
              showClearButton={true}
              width={isMobile ? '80%' : '30%'}
              value={basketName}
              onValueChanged={(e) => handleChangeBasketName(e)}
            />
            <button type="button" className="btn btn-outline-success ms-2 me-2" onClick={handleSaveBasketFunc}>Zapisz</button>
            <button type="button" className="btn btn-outline-danger" onClick={() => setShowSaveBasketForm(false)}>Anuluj</button>
          </div>
        )}
        {generateProducts()}
        <div className='d-flex align-items-center element-pointer mt-2 mb-3' style={{ fontSize: '16px' }} onClick={() => navigate('/Shop')}>
          <IoIosArrowBack size={25} />
          <span className='ms-3'>Kontynuuj zakupy</span>
        </div>
      </div>
    </>
  )
}

export default CartProducts